<div class="controls-container">
    <div class="controls-header">Sidebar</div>

    <div class="controls-sub-header">Sidebar</div>

    <div style="display: flex;height: 400px;">
        <pm-sidebar #Sidebar 
                    [FlexBasisPx]="300"
                    Header="Header"
                    RibbonHeader="Ribbon Header">
            <div sidebar-body style="display: flex; align-items: center; justify-content: center; height: 100%;"> Side Bar </div>
            <div sidebar-ribbon>
                <pm-button class="sidebar-button-container" ButtonClass="button-sidebar">
                    <pm-icon-file-text ></pm-icon-file-text>
                </pm-button>
            </div>
        </pm-sidebar>

        <pm-thumb [ItemOrientation]="'Horizontal'"
                  [Mode]="'Basis'"
                  [ElementFlexBasis]="Sidebar">
        </pm-thumb>

        <div style="flex:1;"> Main Area </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/sidebar/sidebar.html